import API from './API';
function getDrawCategories(config) {
    return API.get('/draw_categories', config);
}
export default {
    getDrawCategories: getDrawCategories
};
